import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { DynamicScreenHeightModule } from '@app/app/directives/dynamic-screen-height/dynamic-screen-height.module';
import { DscrFinancesComponent } from './views/dscr-finances/dscr-finances.component';
import { FinanceViewComponent } from './views/finance-view/finance-view.component';
import { DscrDocumentService } from '@app/app/components/businesses/finances/dscr-document.service';

@Component({
  selector: 'app-finances',
  imports: [
    CommonModule,
    RouterModule,
    MatTabsModule,
    DynamicScreenHeightModule,
    DscrFinancesComponent,
    FinanceViewComponent
  ],
  templateUrl: './finances.component.html'
})
export class FinancesComponent {
  private _dscrDocumentService = inject(DscrDocumentService);

  handleSelectedTabChange(): void {
    this._dscrDocumentService.isDocumentVisible.set(false);
  }
}
